import React from 'react';
import { getTimeLeft } from './fleetConstants';

function FleetLaneCard({ lane, isSelected, onSelect, deployWindowOpen }) {
  return (
    <div
      className={`fleet-lane-card ${lane.status === 'FREE' ? 'lane-free' : 'lane-busy'} ${lane.automationLane ? 'lane-automation' : ''} ${lane.reserved ? 'lane-reserved' : ''} ${isSelected ? 'lane-selected' : ''}`}
      onClick={(e) => { e.stopPropagation(); onSelect(lane); }}
    >
      <div className={`lane-status-dot ${lane.status === 'FREE' ? 'dot-free' : 'dot-busy'}`} />
      <div className="lane-card-info">
        <span className="lane-card-id">
          {lane.hardwareId || lane.laneId}{lane.reserved ? ' 🔒' : ''}
          {deployWindowOpen && lane.dsn && (
            <span className="lane-card-deploy-pill" title="Deployment in progress — open the lane to see status">🚀 deploy</span>
          )}
        </span>
        <span className="lane-card-type">{lane.deviceId?.replace(/^NPEWFM\d+/, '')}</span>
        {lane.dsn && <span className="lane-card-dsn">dsn:{lane.dsn}</span>}
        {lane.reserved && <span className="lane-card-reserved-tag">Automation Reserved</span>}
      </div>
      {lane.status === 'IN_USE' && (
        <div className="lane-card-bottom">
          <span className="lane-card-user">{lane.allocatedBy}</span>
          {lane.allocatedAt && <span className="lane-card-timer">{getTimeLeft(lane.allocatedAt, lane.leaseDuration)}</span>}
        </div>
      )}
    </div>
  );
}

export default FleetLaneCard;
